import {useState, useEffect} from 'react'
import { styled } from '@mui/material/styles';
import {Container, Typography, Box} from '@mui/material';
import printIcon from '../assets/images/printIcon.svg';
import { changeDateFormat } from "../utils/Helper";
import { Button } from "../components";
import { useOktaAuth } from '@okta/okta-react';
import { useSelector } from 'react-redux';
import { authorizedDistributorContent } from '../data/Footer/authorizedDistributorContent';
import { dscsaContent } from '../data/Footer/dscsaContent';
import { gameContent } from '../data/Footer/gameContent';
import { packingSlipContent } from '../data/Footer/packingSlipContent';
import { participatingPhysicianBuyingGroupsContent } from '../data/Footer/participatingPhysicianBuyingGroupsContent';
import { privacyPolicyContent } from '../data/Footer/privacyPolicyContent';
import { returnGoodsPolicyContent } from '../data/Footer/returnGoodsPolicyContent';
import { seasonalReturnWindowContent } from '../data/Footer/seasonalReturnWindowContent';
import { termsAndConditionsOfSaleContent } from '../data/Footer/termsAndConditionsOfSaleContent';
import { termsOfUseContent } from '../data/Footer/termsOfUseContent';
import { wacDisclosureContent } from '../data/Footer/wacDisclosureContent';
import ComposePageRichTextRenderer from '../utils/ComposePageRichTextRenderer';

const BannerContainer = styled('div')(
    ({ aboveFoldBGImage,theme: { palette: { primary }, breakpoints } }) => `
    background-image: url(${aboveFoldBGImage});
    background-size: cover;
    background-position: right;
    background-color: ${primary.main};
    height: 200px;
    ${[breakpoints.down('sm')]} {
        background-image: unset;
        height: 180px;
    }
    `
);

const BannerContentContainer = styled('div')(({ theme: { breakpoints } }) => `
    display: flex;
    font-family: 'Aeonik Regular', 'Arial';
    color: #FFF;
    justify-content: space-between;
    align-items: center;
    max-width: 1050px;
    height: 100%;
    margin: 0 auto;
    ${[breakpoints.down('sm')]} {
        justify-content: space-around;
        flex-direction: column;
        padding: 36px;
    }
`);

const ComposePage = ({ relativePathname, setShowNavigationAlert, setExternalLink, setExternalLinkModalType }) => {
  const { authState } = useOktaAuth() || '';
  const [staticContent, setStaticContent] = useState([]);
  const [staticBannerContent, setStaticBannerContent] = useState([]);
  const locale = useSelector((state) => {
    return state.globalStates.locale
  });

  const getPageContentFromPath = (pathname) => {
    relativePathname = pathname.includes(`${locale}`) ?  pathname.replace(`/${locale}/`,"") : pathname.replace('/',"");
    const contentMapper = {
      'wac-disclosure': wacDisclosureContent,
      'privacy-policy': privacyPolicyContent,
      'terms-of-use': termsOfUseContent,
      'game': gameContent,
      'return-goods-policy': returnGoodsPolicyContent,
      'participating-physician-buying-groups': participatingPhysicianBuyingGroupsContent,
      'dscsa': dscsaContent,
      'notice-of-seasonal-return-window': seasonalReturnWindowContent,
      'authorized-distributor': authorizedDistributorContent,
      'packing-slip': packingSlipContent,
      'terms-and-conditions-of-sale': termsAndConditionsOfSaleContent,
    }
    return contentMapper[relativePathname];
  }

  useEffect(() => {
      if (relativePathname !== "/") {
        let bannerContent, richTextContent;
    
        getPageContentFromPath(relativePathname)?.items[0]?.fields?.content?.fields?.modules.forEach((item) => {
            if (item?.fields?.title.includes("Banner")) {
                bannerContent = item;
            } 
            if (item?.fields?.title && !item?.fields?.title.includes("Banner")) {
                richTextContent = item;
            }
        });
    
        setStaticBannerContent(bannerContent);
        setStaticContent(richTextContent);
    } 
  },[relativePathname]);

  return (
    <div style={!authState?.isAuthenticated ? {position: "relative", margin: "0 auto"} : {}}>
         <BannerContainer aboveFoldBGImage={staticBannerContent?.fields?.backgroundImage?.fields?.file?.url}>
            <BannerContentContainer>
                <Typography variant={'h1'}>{staticBannerContent?.fields?.headline}</Typography>
            </BannerContentContainer>
        </BannerContainer>
        
        <Container maxWidth="md" sx={{paddingTop:"50px" , '@media screen and (max-width: 500px)': {padding: "50px 36px"}}}>
            <Box display='flex' justifyContent='space-between'>
                {staticContent?.fields?.effectiveDate && <Typography variant="body2" sx={{'@media screen and (max-width: 500px)': {fontSize: "16px",}}} gutterBottom>
                    {staticContent?.fields?.effectiveDateLabel} {changeDateFormat(staticContent?.fields?.effectiveDate)}
                </Typography>}
                <Box display='flex' sx={{cursor: 'pointer'}} onClick={() => window.print()}>
                  <img src={printIcon} height="20" width="20" alt="PRINT"/><span>{staticContent?.fields?.printButtonLabel}</span>
                </Box>
            </Box>
            <Typography variant="subtitle2" gutterBottom sx={{fontWeight:"bold" , '@media screen and (max-width: 500px)': {fontSize: "16px",}}}>
                {staticContent?.fields?.disclaimerMessage}
            </Typography>
            <Box sx={{ height: "auto", color: "primary.main",fontFamily: "Aeonik Regular, Arial" }} >
                <ComposePageRichTextRenderer
                  jsonData={staticContent?.fields?.content}
                  setShowNavigationAlert={setShowNavigationAlert}
                  setExternalLink={setExternalLink}
                  setExternalLinkModalType={setExternalLinkModalType}
                />
            </Box>
            <Box display='flex' justifyContent='space-evenly' width={{xs:'60%', sm:'40%'}} margin='50px auto'>
              { staticContent?.fields?.backToTopButtonLabel &&
                <Button
                buttonType="secondary" 
                onClick={() => window.scrollTo({top:0, behavior: 'smooth'})}>
                    {staticContent?.fields?.backToTopButtonLabel}
                </Button>}
            </Box>
        </Container>
    </div>
  )
}

export default ComposePage
